module.exports = __webpack_public_path__ + "static/img/goods-1600.0aa7744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-1600.png
// module id = f6De
// module chunks = 2